import {AnalyticsBrowser} from '@segment/analytics-next'

let segmentAnalytics = null
let segmentReadyResolve
const segmentReady = new Promise((resolve) => {
    segmentReadyResolve = resolve
})

export const initializeSegment = async (segmentKey) => {
    if (!segmentKey || segmentAnalytics) return
    // `AnalyticsBrowser.load()` returns a thenable AnalyticsBrowser instance
    // that queues track/identify/page calls until the SDK finishes loading.
    // Expose it on `window` synchronously so externally-rendered surfaces
    // (Bloomreach web layers configured in Exponea Engagement, GTM
    // custom-HTML tags, browser extensions) can call `analytics.track()` with
    // no race window — calls before load complete are queued and dispatched
    // on completion. SFRA had this implicitly via the classic Segment
    // snippet; `@segment/analytics-next` is module-scoped by default.
    // SFCC-10693.
    const analyticsBrowser = AnalyticsBrowser.load({writeKey: segmentKey})
    if (typeof window !== 'undefined') {
        window.analytics = analyticsBrowser
    }

    try {
        const [analytics] = await analyticsBrowser
        segmentAnalytics = analytics
        segmentReadyResolve(analytics)
    } catch (error) {
        console.error('Error initializing Segment Analytics:', error)
        segmentReadyResolve(null)
    }
}

export const getSegmentInstance = () => segmentAnalytics

export const getSegmentReady = () => segmentReady
